<template>
    <div class="transactionPeriodMamMaster white border-radius5 mar-bot10 summary-page">
        <div
           class="period-header module-header display-flex flex-start"
        >
            <span class="title theme-font-color">{{$t('Trading_cycle')}}</span>
        </div>
        <div class="el-table-outer">
            <el-table
                    :data="listData"
                    v-loading="loading"
                    :empty-text="$t('root.noData')"
                    show-summary
                    :summary-method="getSummaries"
                    :header-cell-style="{ background: '#F3F2F7',color: '#5E5873',}"
            >
                <div class="table-nodata" slot="empty">
                    {{$t('root.noData')}}
                </div>
                <el-table-column
                        :label="$t('Issue')"
                        prop="issueNumber"
                        min-width="140px"
                >
                </el-table-column>
                <el-table-column
                        :label="$t('Management_days')"
                        prop="managePeriod"
                >
                    <template slot-scope="scope">
                        <div>{{scope.row.managePeriod}}{{$t('day')}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('Manage_funds')"
                        prop="managementAmount"
                        min-width="100px"
                        sortable
                >
                    <template slot-scope="scope">
                        <div
                                class="copy-yeild color-span"
                        >{{scope.row.managementAmount}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('Subscription_revenue')"
                        prop="copyProfit"
                        min-width="100px"
                        sortable
                >
                    <template slot-scope="scope">
                        <div
                                class="copy-yeild color-span"
                                :class="{
                                  'theme-green': !isIncludeMinus(scope.row.copyProfit),
                                  'theme-color': isIncludeMinus(scope.row.copyProfit),
                                }"
                        >{{scope.row.copyProfit}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('Subscription_yield')"
                        sortable
                        prop="copyProfitRate"
                        min-width="120px"
                >
                </el-table-column>
                <el-table-column
                        :label="$t('management_fee')"
                        prop="managementPrice"
                        min-width="100px"
                        sortable
                >
                    <template slot-scope="scope">
                        <div
                                class="copy-yeild color-span"
                        >{{scope.row.managementPrice}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('Performance_fee')"
                        min-width="100px"
                        prop="performancePrice"
                        sortable
                >
                    <template slot-scope="scope">
                        <!--进行中和结算中的就是估算值,因为表现费有可能浮动 -->
                        <span>{{scope.row.performancePrice}} <span v-if="scope.row.status == 1">({{$t('Estimate')}})</span></span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('User.status')"
                        prop="status"
                >
                    <template slot-scope="scope">
                        <span
                                class="pointer tag-box tag"
                                :style="getStyle(scope.row.status)"
                        >{{getStatus(scope.row)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-outer" v-if="total">
              <div class="paginnation-left">
                <size-change @sizeChange="sizeChange"></size-change>
                <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
              </div>
              <vs-pagination
                class="pagination-box"
                :max="max"
                :total="pageSize"
                v-model="page"
              ></vs-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {colorRgba} from "@/utils";
import { isIncludeMinus } from '@/utils/common';
  import { mapGetters } from 'vuex';
  import initData2 from '@/mixins/initData';
  export default {
    name: 'transactionPeriodMamMaster',
    props: {
      subId: {
        type: Number,
        default: 0
      },
    },
    mixins: [initData2],
    data() {
      return {
        statistics: {
          totalProfit: 0,
        },
        green: '#28C76F',
        yellow: '#FF9F43',
        grayBg: '#BABFC7',
        grayColor: '#BABFC7',
      };
    },
    watch:{
      subId(val){
        if(val){
          this.init();
        }
      },
    },
    mounted() {
      this.$nextTick(() => {

        this.init();
      })
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster']),
    },
    methods: {
      isIncludeMinus,
      beforeInit(){
        if(!this.subId) {
          return false;
        }
        this.params = {
          mtId: +this.$route.params.mtid,
          page: this.page - 1,
          size: this.size,
          subId: this.subId,
        }
        if(this.sort){
          this.params.sort = this.sort;
        }
        this.url = '/crm/reception/queryCopyTradingCycles';
        return true;
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          switch (column.property) {
            case 'issueNumber':
              sums[index] = this.$t('User.total');
              break;
            case 'managementAmount':
            case 'copyProfitRate':
            case 'status':
              sums[index] = `-`;
              break;
            case 'managePeriod':
              sums[index] = `${this.statistics.totalManagePeriod}`;
              break;
            case 'copyProfit':
              sums[index] = `${this.statistics.totalProfit}`;
              break;
            case 'managementPrice':
              sums[index] = `${this.statistics.totalManagementPrice}`;
              break;
            case 'performancePrice':
              sums[index] = `${this.statistics.totalPerformancePrice}`;
              break;
          }
        });
        return sums;
      },
      getStatus(row){
        switch (row.status) {
          case 1:
            return this.$t('withgold.statusDuring');
          case 2:
          case 3:
            return this.$t('settled');
          case 4:
            return this.$t('To_open_the_next_issue');
        }
      },
      getStyle(status){
        switch (status) {
          case 1:
            return {
              backgroundColor:  colorRgba(this.green,0.1),
              color:  this.green,
            };
          case 2:
          case 3:
            return {
              backgroundColor:  colorRgba(this.yellow,0.1),
              color:  this.yellow,
            }

          case 4:
            return {
              backgroundColor:  colorRgba(this.grayBg,0.1),
              color:  this.grayColor,
            };
        }
      }
    },
  };
</script>
<style lang="scss" scoped>
.transactionPeriodMamMaster {
    .title {
        font-size:16px;
        font-weight: bold;
    }
    .el-table-outer {
        padding-bottom: 20px;
    }
  .pagination-outer {
    padding-bottom: 0;
  }
  .module-header {
    padding-left: 20px!important;
  }
  /deep/ .el-table {
    tr > th:first-child,
    tr > td:first-child {
      padding-left: 10px!important;
    }
  }
  .pagination-outer {
    padding-left: 20px!important;
  }
  /deep/ .el-table::before {
    height: 0!important;
  }
}
</style>
